import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isSuperAdmin, isEngineer, getCurrentUser } from "../../services/authService";

const EngineerRoute = (props) => {
  const { path, component: Component, render, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!getCurrentUser()) {
          return <Redirect to="/login" />;
        } else if (!isEngineer() && !isSuperAdmin()) {
          return <Redirect to="/unauthorized" />;
        } else {
          return Component ? <Component {...props} /> : render(props);
        }
      }}
    />
  );
};

export default EngineerRoute;
